import { StyleSheet } from 'aphrodite';

const ANIMATION = {
  from: {
    transform: 'rotate(0deg)',
  },
  to: {
    transform: 'rotate(360deg)',
  },
};

export const styles = StyleSheet.create({
  spinnerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '30vh',
  },

  spinner: {
    width: '50px',
    height: '50px',
    display: 'block',
    animationName: ANIMATION,
    animationDuration: '1.2s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    backgroundImage: 'url(../../assets/icon_loading.png)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
});
